import { useMemo } from 'react';

import ActionCell from 'components/DataTableComponent/components/ActionCell';

export const useProductTableColumns: any = (
  handleDeleteProduct: (id: string) => void,
  handleEditProduct: (id: string) => void
) => {
  return useMemo(
    () => [
      {
        accessorKey: 'image',
        header: 'Image',
        size: 95,
        cell: ({ getValue }: any) => (
          <img src={getValue()} alt="product" className="w-12 h-12" />
        )
      },
      {
        accessorKey: 'displayName',
        header: 'Name',
        size: 91,
        cell: ({ getValue }: any) => getValue()
      },
      {
        accessorKey: 'quantity',
        header: 'Amount',
        size: 78,
        cell: ({ getValue }: any) => getValue()
      },
      {
        accessorKey: 'priority',
        header: 'Type',
        size: 94,
        cell: ({ getValue }: any) => getValue() || ''
      },
      {
        accessorKey: 'actions',
        header: null,
        size: 49,
        cell: ({ row }: any) => (
          <ActionCell
            rowData={row.original}
            actions={[
              {
                label: 'Edit',
                handler: () => handleEditProduct(row.original.id)
              },
              {
                label: 'Delete',
                handler: () => handleDeleteProduct(row.original.id)
              }
            ]}
          />
        )
      }
    ],
    [handleEditProduct, handleDeleteProduct]
  );
};
